// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"264ce0dd","171":"b99d414b","350":"b9c38d3c","418":"54878f72","541":"04d190a0","580":"c688944b","694":"bc006f08","772":"2826e42d","906":"4496fd2a"}[chunkId] + ".chunk.js";
};